import { escapeForScript } from './utils';

export interface JsonLdProps {
  data: Record<string, unknown> | unknown[] | string;
  id: string;
}

export function JsonLd({ data, id }: JsonLdProps) {
  const serialized = typeof data === 'string' ? data : JSON.stringify(data);
  return (
    <script dangerouslySetInnerHTML={{ __html: escapeForScript(serialized) }} id={id} type="application/ld+json" />
  );
}
